// @mui
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
// icons
import { ChevronRight, Settings } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
// config
import { HEADER } from "../../../../config";
import Toolbar from "@mui/material/Toolbar";
// hooks
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth, useHelmet } from "../../../../hooks";
import { paths } from "routes/paths";
import { IRequest } from "types/requests.types";

const StyledHeader = styled(Toolbar)(({ theme }) => ({
  width: "100%",
  height: HEADER.MOBILE_HEIGHT,
  zIndex: theme.zIndex.appBar + 1,
  padding: theme.spacing(3),
  overflow: "hidden",
  borderBottomLeftRadius: theme.shape.borderRadius,
  borderBottomRightRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  transition: theme.transitions.create(["width", "height"], {
    duration: theme.transitions.duration.shorter,
  }),
  position: "fixed",
  top: 0,
  left: 0,
}));
export const PagesHeader = () => {
  const { title } = useHelmet();
  const { pathname, state }: { pathname: string; state: IRequest } =
    useLocation();
  const { user } = useAuth();
  const navigate = useNavigate();

  const isProfilePage = [paths.profile].includes(pathname);
  const isAnotherUserRequest = user?.username !== state?.user?.username;
  const isSuperAdmin = user?.roles.includes("superAdmin");
  const isHR = user?.job === "hr";
  const showEditRequest =
    (isHR &&
      [paths.applications.details, paths.pendingActions.approve].includes(
        pathname
      )) ||
    (state?.status === 1 &&
      [paths.applications.details].includes(pathname) &&
      !isAnotherUserRequest) ||
    ([paths.applications.details].includes(pathname) && isSuperAdmin);

  function handleBack() {
    navigate(-1);
  }
  function handleToEdit() {
    const identifier = state?.form?.identifier === "leaveHour"
      ? "leave"
      : state?.form?.identifier;

    // Employee action requests don't have edit pages
    if (identifier === "employeeActionWarning" || identifier === "employeeActionAppreciation") {
      return;
    }

    navigate(
      // @ts-ignore
      paths.applications[`${identifier}Edit`],
      { state }
    );
  }
  function handleNavigateSettings() {
    navigate(paths.settings);
  }

  return (
    <StyledHeader>
      <Stack
        flexDirection={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
        sx={{
          height: "100%",
          width: "100%",
        }}
      >
        <IconButton size={"medium"} onClick={handleBack}>
          <ChevronRight />
        </IconButton>

        <Typography>{title}</Typography>

        {isProfilePage ? (
          <IconButton size={"medium"} onClick={handleNavigateSettings}>
            <Settings />
          </IconButton>
        ) : showEditRequest ? (
          <IconButton size={"medium"} onClick={handleToEdit}>
            <EditIcon />
          </IconButton>
        ) : (
          <IconButton size={"medium"} disabled sx={{ visibility: "hidden" }}>
            <Settings />
          </IconButton>
        )}
      </Stack>
    </StyledHeader>
  );
};
